module.exports = __webpack_public_path__ + "static/media/logo-senhorbonfim.d8cd732a.png";